import {
  SentNewsEntity,
} from './sentNewsEntity';
import { AlreadyRead } from './valueObjects/alreadyRead';
import { Category } from './valueObjects/category';
import { ContentS3Path } from './valueObjects/contentS3Path';
import { CreateDatetime } from './valueObjects/createDatetime';
import { FromId } from './valueObjects/fromId';
import { Title } from './valueObjects/title';
import { ToId } from './valueObjects/toId';

import type {
  SentNewsJsonPub,
  SentNewsJsonPvt,
  SentNewsPropsPub,
  SentNewsPropsPvt,
} from './sentNewsEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * SentNewsFactory
 */
export class SentNewsFactory extends FactoryPub<
  SentNewsEntity,
  SentNewsPropsPvt,
  SentNewsJsonPvt,
  SentNewsPropsPub,
  SentNewsJsonPub
> {
  comparePub = (
    a: EntityDataPubType<SentNewsJsonPvt, SentNewsJsonPub>,
    b: EntityDataPubType<SentNewsJsonPvt, SentNewsJsonPub>,
  ) => {
    const da = new Date(a.data.sendDatetime);
    const db = new Date(b.data.sendDatetime);
    return da < db ? 1 : -1;
  };

  create(
    props: SentNewsPropsPvt,
    propsPub: EntityPubNotNullType<SentNewsPropsPub>,
  ): SentNewsEntity {
    return new SentNewsEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<SentNewsJsonPvt, SentNewsJsonPub>,
  ): SentNewsEntity {
    return this.create({
      sendDatetime: CreateDatetime.create(new Date(props.data.sendDatetime)),
      title: Title.create(props.data.title),
      category: Category.create(props.data.category),
      s3Path: ContentS3Path.create(props.data.s3Path),
      fromId: FromId.create(props.data.fromId),
      toId: ToId.create(props.data.toId),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {
        alreadyRead: AlreadyRead.create(props.pub.data.alreadyRead),
      },
    });
  }
}
